import * as React from 'react';
import { useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { makeStyles } from '@mui/styles';
import dayjs from 'dayjs';
import { CustomSetting, inputDateFormat } from 'types/types';

const useStyles = makeStyles((theme) => ({
  dateField: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(2)
  }
}));

type DatefieldSectionProps = {
  inputSetting: CustomSetting;
  initialSelectValue: any;
  setSave: React.Dispatch<
    React.SetStateAction<Record<string, string | boolean>>
  >;
};

export const DatefieldSection: React.FC<DatefieldSectionProps> = ({
  inputSetting,
  initialSelectValue,
  setSave
}: DatefieldSectionProps) => {
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = useState(
    initialSelectValue
      ? dayjs(initialSelectValue).format(inputDateFormat)
      : dayjs(new Date().toJSON()).format(inputDateFormat)
  );

  React.useEffect(() => {
    if (inputSetting?.id === undefined) return;
    const id = inputSetting.id;
    setSave((prev: any) => ({ ...prev, [id]: selectedDate }));
  }, [selectedDate, setSave, inputSetting?.id]);

  return (
    <div data-testid="render-datefield-component">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          className={classes.dateField}
          openTo="year"
          views={['year', 'month', 'day']}
          inputFormat={inputDateFormat}
          value={selectedDate}
          onChange={(newValue: any) =>
            setSelectedDate(newValue.format(inputDateFormat))
          }
          renderInput={(params) => (
            <TextField {...params} helperText={inputDateFormat} />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};
